export default "__VITE_ASSET__RaTsV3pG__"